module.exports = __webpack_public_path__ + "img/menu.b1db5241.svg";